import React, { useState, useEffect } from 'react';
import { getStudents, addFeeTemplate, getFeeTemplates, deleteFeeTemplate, getAllFees, updateFee, addFee } from '../../api';
import { toast } from 'react-toastify';

const ManageFees = () => {
  const [students, setStudents] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [allFees, setAllFees] = useState([]);
  const [showAddFee, setShowAddFee] = useState(false);
  const [addFeeData, setAddFeeData] = useState({ student_id: '', amount: '', fee_type: 'Monthly Fee', month: '', year: new Date().getFullYear() });
  const [activeTab, setActiveTab] = useState('fees');
  const [formData, setFormData] = useState({ student_id: '', amount: '', fee_type: 'Monthly Fee' });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [studRes, tempRes, feesRes] = await Promise.all([
        getStudents(), getFeeTemplates(), getAllFees()
      ]);
      setStudents(studRes.data);
      setTemplates(tempRes.data);
      setAllFees(feesRes.data);
    } catch (err) { toast.error('Error loading data'); }
  };

  const handleAddTemplate = async (e) => {
    e.preventDefault();
    try {
      await addFeeTemplate(formData);
      toast.success('Fee template saved! Auto-generates every month.');
      setFormData({ student_id: '', amount: '', fee_type: 'Monthly Fee' });
      loadData();
    } catch (err) { toast.error('Error saving template'); }
  };

  const handleDeleteTemplate = async (id) => {
    if (!window.confirm('Delete this template?')) return;
    try {
      await deleteFeeTemplate(id);
      toast.success('Template deleted!');
      loadData();
    } catch (err) { toast.error('Error deleting'); }
  };

  const handleMarkPaid = async (id) => {
    try {
      await updateFee(id, { status: 'paid', paid_date: new Date().toISOString().split('T')[0] });
      toast.success('Fee marked as paid!');
      loadData();
    } catch (err) { toast.error('Error updating fee'); }
  };

  const handleMarkUnpaid = async (id) => {
    try {
      await updateFee(id, { status: 'unpaid', paid_date: null });
      toast.success('Fee marked as unpaid!');
      loadData();
    } catch (err) { toast.error('Error updating fee'); }
  };

  const handleAddFee = async (e) => {
    e.preventDefault();
    try {
      await addFee(addFeeData);
      toast.success('Fee added successfully!');
      setShowAddFee(false);
      setAddFeeData({ student_id: '', amount: '', fee_type: 'Monthly Fee', month: '', year: new Date().getFullYear() });
      loadData();
    } catch (err) { toast.error('Error adding fee'); }
  };

  return (
    <div>
      <h3 style={{ color: '#1a3a5c', marginBottom: '20px' }}>💰 Manage Fees</h3>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button style={{ ...styles.tab, ...(activeTab === 'fees' ? styles.activeTab : {}) }}
          onClick={() => setActiveTab('fees')}>📋 All Fees</button>
        <button style={{ ...styles.tab, ...(activeTab === 'templates' ? styles.activeTab : {}) }}
          onClick={() => setActiveTab('templates')}>🔄 Monthly Templates</button>
      </div>

      {/* TEMPLATES TAB */}
      {activeTab === 'templates' && (
        <div>
          <div style={styles.card}>
            <h4 style={{ color: '#1a3a5c', margin: '0 0 15px' }}>➕ Add Monthly Fee Template</h4>
            <p style={{ color: '#666', fontSize: '13px', margin: '0 0 15px' }}>
              ⚡ Ek baar set karo - har month 1 tarikh ko automatically fee add hogi!
            </p>
            <form onSubmit={handleAddTemplate}>
              <div style={styles.formGrid}>
                <div>
                  <label style={styles.label}>Student</label>
                  <select style={styles.input} value={formData.student_id}
                    onChange={e => setFormData({...formData, student_id: e.target.value})} required>
                    <option value="">Select Student</option>
                    {students.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                  </select>
                </div>
                <div>
                  <label style={styles.label}>Amount (Rs.)</label>
                  <input style={styles.input} type="number" placeholder="e.g. 5000"
                    value={formData.amount}
                    onChange={e => setFormData({...formData, amount: e.target.value})} required />
                </div>
                <div>
                  <label style={styles.label}>Fee Type</label>
                  <select style={styles.input} value={formData.fee_type}
                    onChange={e => setFormData({...formData, fee_type: e.target.value})}>
                    <option value="Monthly Fee">Monthly Fee</option>
                    <option value="Exam Fee">Exam Fee</option>
                    <option value="Lab Fee">Lab Fee</option>
                  </select>
                </div>
              </div>
              <button type="submit" style={styles.addBtn}>💾 Save Template</button>
            </form>
          </div>

          <div style={styles.card}>
            <h4 style={{ color: '#1a3a5c', margin: '0 0 15px' }}>🔄 Active Templates</h4>
            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHeader}>
                  <th style={styles.th}>Student</th>
                  <th style={styles.th}>Fee Type</th>
                  <th style={styles.th}>Amount</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {templates.length === 0 && (
                  <tr><td colSpan="4" style={styles.empty}>Koi template nahi hai!</td></tr>
                )}
                {templates.map(t => (
                  <tr key={t.id} style={styles.tableRow}>
                    <td style={styles.td}>{t.student_name}</td>
                    <td style={styles.td}>{t.fee_type}</td>
                    <td style={styles.td}><strong>Rs. {parseFloat(t.amount).toLocaleString()}</strong></td>
                    <td style={styles.td}>
                      <button style={styles.deleteBtn} onClick={() => handleDeleteTemplate(t.id)}>🗑️ Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ALL FEES TAB */}
      {activeTab === 'fees' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
            <button style={styles.addBtn} onClick={() => setShowAddFee(true)}>➕ Add Fee</button>
          </div>

          {showAddFee && (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ background: 'white', borderRadius: '12px', padding: '30px', width: '450px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
                <h4 style={{ color: '#1a3a5c', marginTop: 0 }}>➕ Add New Fee</h4>
                <form onSubmit={handleAddFee}>
                  <div style={styles.formGrid}>
                    <div>
                      <label style={styles.label}>Student</label>
                      <select style={styles.input} value={addFeeData.student_id}
                        onChange={e => setAddFeeData({...addFeeData, student_id: e.target.value})} required>
                        <option value="">Select Student</option>
                        {students.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={styles.label}>Amount (Rs.)</label>
                      <input style={styles.input} type="number" placeholder="e.g. 5000"
                        value={addFeeData.amount}
                        onChange={e => setAddFeeData({...addFeeData, amount: e.target.value})} required />
                    </div>
                    <div>
                      <label style={styles.label}>Fee Type</label>
                      <select style={styles.input} value={addFeeData.fee_type}
                        onChange={e => setAddFeeData({...addFeeData, fee_type: e.target.value})}>
                        <option>Monthly Fee</option>
                        <option>Exam Fee</option>
                        <option>Lab Fee</option>
                      </select>
                    </div>
                    <div>
                      <label style={styles.label}>Month</label>
                      <select style={styles.input} value={addFeeData.month}
                        onChange={e => setAddFeeData({...addFeeData, month: e.target.value})} required>
                        <option value="">Select Month</option>
                        {['January','February','March','April','May','June','July','August','September','October','November','December'].map(m => (
                          <option key={m} value={m}>{m}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label style={styles.label}>Year</label>
                      <input style={styles.input} type="number" value={addFeeData.year}
                        onChange={e => setAddFeeData({...addFeeData, year: e.target.value})} required />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                    <button type="submit" style={styles.addBtn}>💾 Save Fee</button>
                    <button type="button" style={{...styles.addBtn, background: '#6c757d'}} onClick={() => setShowAddFee(false)}>Cancel</button>
                  </div>
                </form>
              </div>
            </div>
          )}

          <div style={styles.card}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHeader}>
                  <th style={styles.th}>Student</th>
                  <th style={styles.th}>Fee Type</th>
                  <th style={styles.th}>Amount</th>
                  <th style={styles.th}>Month</th>
                  <th style={styles.th}>Status</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {allFees.length === 0 && (
                  <tr><td colSpan="6" style={styles.empty}>Koi fee record nahi!</td></tr>
                )}
                {allFees.map(f => (
                  <tr key={f.id} style={styles.tableRow}>
                    <td style={styles.td}>{f.student_name}</td>
                    <td style={styles.td}>{f.fee_type || '-'}</td>
                    <td style={styles.td}><strong>Rs. {parseFloat(f.amount).toLocaleString()}</strong></td>
                    <td style={styles.td}>{f.month} {f.year}</td>
                    <td style={styles.td}>
                      <span style={{ ...styles.badge,
                        background: f.status === 'paid' ? '#d4edda' : '#f8d7da',
                        color: f.status === 'paid' ? '#155724' : '#721c24' }}>
                        {f.status === 'paid' ? '✅ Paid' : '❌ Unpaid'}
                      </span>
                    </td>
                    <td style={styles.td}>
                      {f.status !== 'paid'
                        ? <button style={styles.paidBtn} onClick={() => handleMarkPaid(f.id)}>Mark Paid ✅</button>
                        : <button style={styles.unpaidBtn} onClick={() => handleMarkUnpaid(f.id)}>Mark Unpaid</button>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  tab: { padding: '10px 20px', border: '2px solid #1a3a5c', borderRadius: '8px', cursor: 'pointer', background: 'white', color: '#1a3a5c', fontWeight: '600' },
  activeTab: { background: '#1a3a5c', color: 'white' },
  card: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '15px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', marginTop: '5px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555' },
  addBtn: { padding: '10px 20px', background: '#0d6efd', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  deleteBtn: { padding: '6px 12px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHeader: { background: '#1a3a5c' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'left', fontSize: '13px' },
  tableRow: { borderBottom: '1px solid #eee' },
  td: { padding: '12px 15px', fontSize: '13px', color: '#444' },
  empty: { textAlign: 'center', color: '#999', padding: '40px' },
  badge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
  paidBtn: { padding: '6px 12px', background: '#28a745', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
  unpaidBtn: { padding: '6px 12px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
};

export default ManageFees;